<template>
  <div class="flex justify-end items-center">
    <span class="text-sm text-333 mr-4">对自己有帮助！分享给好友</span>
    <el-popover trigger="hover">
      <div slot="reference">
        <img class="inline-block w-8" :src="require('@/assets/images/weixin.png')" />
        <img class="inline-block w-8 ml-3" :src="require('@/assets/images/pengyouquan.png')" />
      </div>

      <div class="py-3">
        <canvas ref="qrCode" class="block mx-auto"></canvas>
        <div class="text-center mt-4 text-sm text-333">微信扫一扫分享</div>
      </div>
    </el-popover>
  </div>
</template>
<script>
import QRCode from 'qrcode';
export default {
  name: 'Share',
  mounted() {
    this.createQrcode();
  },
  methods: {
    /**
     * 生成二维码
     */
    createQrcode() {
      QRCode.toCanvas(this.$refs.qrCode, location.href, { width: 80, margin: 0 });
    },
  },
};
</script>
